
export const farsiToEnglishDigitsMap = {
    '۰': 0, '۱': 1, '۲': 2,
    '۳': 3, '۴': 4, '۵': 5,
    '۶': 6, '۷': 7, '۸': 8, '۹': 9
}

export const englishToFarsiDigitsMap = '۰۱۲۳۴۵۶۷۸۹'.split('')

export function toEnglishDigits(text) {
    let convertedText = ''
    for (let i = 0; i < text.length; i++) {
        if (text[i] in farsiToEnglishDigitsMap) {
            convertedText += farsiToEnglishDigitsMap[text[i]]
        } else {
            convertedText += text[i]
        }
    }
    return convertedText
}


// WEBPACK FOOTER //
// ./src/utils.js